export const apps = [
  ["qrcodepro", "QR Code Pro", "com.quantingo.qrcodepro"],
  ["barcodepro", "Barcode Pro", "com.quantingo.barcodepro"],
  ["loteriasia", "Loterias IA", "com.quantingo.loteriasia"],
  ["resus", "Resus", "com.quantingo.resus"],
  ["resusprime", "Resus Prime", "com.quantingo.resusprime"],
  ["sonia", "Sonia AI", "com.quantingo.sonia"],
  ["kaeruhero", "Kaeru Hero", "com.quantingo.kaeruhero"],
  ["spaceescape", "Space Escape", "com.quantingo.spaceescape"],
  [
    "matematicadivertida",
    "Matemática Divertida",
    "com.quantingo.matematicadivertida",
  ],
  [
    "tijoloecologico.standard",
    "Tijolo Ecológico Standard",
    "com.quantingo.TijoloEcologico.standard",
  ],
  [
    "tijoloecologico.premium",
    "Tijolo Ecológico Premium",
    "com.quantingo.TijoloEcologico.premium",
  ],
];
